import { FormControlLabel, formGroupClasses, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircuitCreateStepperData, CircuitCreateStepperStockType } from "./circuitCreateStepper";

interface CircuitCreateStepperPackageStockTypeProps {
    data: CircuitCreateStepperData;
    setData: React.Dispatch<React.SetStateAction<CircuitCreateStepperData>>;
    stepIndex: number;
}

// use_stock ? => stock sur le package
// use_product_stock => stock des produits

export const CircuitCreateStepperPackageStockType: FC<CircuitCreateStepperPackageStockTypeProps> = ({ data, setData, stepIndex }) => {
    const { t } = useTranslation();
    const onChange = (event: { target: { name: any; value: any; }; }) => {
        setData((state) => ({ ...state, [event.target.name]: event.target.value }));
        if (event.target.value === CircuitCreateStepperStockType.PACKAGE_WITHOUT_STOCK) setData((state) => ({ ...state, ['stock_by_rooms']: undefined }));
        if (event.target.value !== CircuitCreateStepperStockType.PACKAGE_WITHOUT_STOCK) setData((state) => ({ ...state, is_dynamic_package: false }));
    };
    return (
        <Stack direction={'column'} justifyContent={'center'} sx={{ maxWidth: 'md', width: '100%', gap: 7 }}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="h3" sx={{ color: '#486284', fontWeight: 700 }}>{t('shared.step-number', { count: stepIndex + 1 })} : {t('shared.stock')}</Typography>
                <Typography variant="subtitle1" sx={{ color: '#8CA2C0', fontWeight: 400 }}>{t('shared.package-stock-type-helper')}</Typography>
            </Stack>
            <Stack direction={'row'} alignItems={'center'} sx={{ width: '100%' }} spacing={2}>
                <RadioGroup
                    value={data.stock_type}
                    name="stock_type"
                    onChange={onChange}
                    sx={{
                        [`&.${formGroupClasses.root}`]: {
                            gap: 2
                        }
                    }}
                >
                    <FormControlLabel
                        value={CircuitCreateStepperStockType.STOCK_ON_THE_PACKAGE}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.stock-on-the-package")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                    <FormControlLabel
                        value={CircuitCreateStepperStockType.PACKAGE_WITHOUT_STOCK}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.package-without-stock")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem', variant: 'body1' } } }}
                    />
                    {
                        !data.without_products && <>
                            <FormControlLabel
                                value={CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT}
                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                                label={t("shared.stock-on-the-product")}
                                componentsProps={{ typography: { sx: { fontSize: '1.5rem', variant: 'body1' } } }}
                            />
                            <FormControlLabel
                                value={CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT_AND_PACKAGE}
                                control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                                label={t("shared.stock-on-the-product-and-package")}
                                componentsProps={{ typography: { sx: { fontSize: '1.5rem', variant: 'body1' } } }}
                            />
                        </>
                    }
                </RadioGroup>

            </Stack>
        </Stack>
    );
};